<template>
    <b-col cols="12"
           lg="9"
           id="section_main"
           class="section-main">
        <futurocoins-from-mining></futurocoins-from-mining>
        <b-row>
            <b-col cols="12">
                <p>My account balance: </p>
                <p class="my_money">FND {{ money.format(accountBalance, 'fnd') }}</p>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <payout-history-table></payout-history-table>
            </b-col>
        </b-row>
    </b-col>
</template>

<script>
    import FuturocoinsFromMining from './dashboard/FuturocoinsFromMining.vue'
    import PayoutHistoryTable from './payout-history/PayoutHistoryTable.vue'

    export default {
        components: { FuturocoinsFromMining, PayoutHistoryTable },
        dependencies: ['money'],
        computed: {
            accountBalance () {
                return this.$store.getters.user.moneyBalance
            }
        }
    }
</script>

<style lang="scss" scoped>
    .space{
        margin-bottom: 30px;
    }

    .profile-edit-data-header{
        h3{
            margin-bottom: 30px;
        }
    }

    .row-buttons{
        margin-top: 30px;
        text-align: right;
    }

    .my_money{
        padding: 20px 0;
        font-size: 1.3em;
    }

    .form-item-radio{
        margin-bottom: 20px;
    }

    .field-error{
        .check{
            background-color: rgba(250, 159, 159, 0.66)!important;
            border-color: #e82828!important;
        }
    }

    @media(min-width: 992px){
        .payout-history{
            text-align: right;
        }
    }

    @media(max-width:991px){
        .row-buttons{
            text-align: left;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/layout/partials/section/content/PayoutHistoryContent.vue